module.exports = __webpack_public_path__ + "static/media/Comercializadora de Frecuencias S.bcda09f4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Comercializadora de Frecuencias S.pdf
// module id = 910
// module chunks = 0